import type { Strings } from './en.ts';

/** اردو. Same keys as en.ts; digits stay Western (0–9). */
export const ur: Strings = {
  app: {
    name: 'Kharcha',
    product: 'by KCloudAI',
    offline: 'آف لائن',
    loading: 'لوڈ ہو رہا ہے…',
    retry: 'دوبارہ کوشش کریں',
    error: 'کچھ غلط ہو گیا',
    cancel: 'منسوخ',
  },
  lang: { switchTo: 'EN' },
  errors: {
    notFoundTitle: 'صفحہ نہیں ملا',
    notFoundBody: 'یہ صفحہ موجود نہیں یا ہٹا دیا گیا ہے۔ پتہ چیک کریں یا ہوم پر واپس جائیں۔',
    serverTitle: 'کچھ غلط ہو گیا',
    serverBody: 'سرور یہ کام مکمل نہیں کر سکا۔ تھوڑی دیر بعد دوبارہ کوشش کریں۔',
    offlineTitle: 'آپ آف لائن ہیں',
    offlineBody: 'اس فون پر ابھی انٹرنیٹ نہیں۔ وائی فائی یا موبائل ڈیٹا چیک کر کے دوبارہ کوشش کریں۔',
    goHome: 'ہوم پر جائیں',
    goBack: 'واپس جائیں',
    tryAgain: 'دوبارہ کوشش کریں',
    code: 'خرابی {{code}}',
    notFoundTip1: 'پتے میں لکھنے کی غلطی چیک کریں۔',
    notFoundTip2: 'یا ہوم پر واپس جا کر مینو سے کھولیں۔',
    serverTip1: 'آپ کے محفوظ اندراجات بالکل ٹھیک ہیں۔ کچھ ضائع نہیں ہوا۔',
    serverTip2: 'جو اندراج ابھی نہیں بھیجے گئے وہ اسی فون پر رہیں گے اور خود بھیج دیے جائیں گے۔',
    serverTip3: 'یہ عام طور پر ایک دو منٹ میں ٹھیک ہو جاتا ہے۔',
    offlineTip1: 'آپ کے محفوظ اندراجات بالکل ٹھیک ہیں۔',
    offlineTip2: 'آپ اندراج کرتے رہیں: وہ اسی فون پر انتظار کریں گے۔',
    offlineTip3: 'انٹرنیٹ واپس آتے ہی وہ خود بھیج دیے جائیں گے۔',
    stillStuck: 'چند بار کوشش کے بعد بھی کام نہیں کر رہا؟ لکھیں',
  },
  theme: {
    dark: 'ڈارک موڈ',
    light: 'لائٹ موڈ',
  },
  login: {
    title: 'لاگ اِن',
    subtitle: 'بس اپنی ای میل۔ ہم کوڈ بھیجیں گے، آپ لکھیں گے، اور آپ اندر۔',
    pitch: 'آپ کی دکان، دفتر یا گھر کا ہر روپیہ، رسید کے ساتھ، اسی کے ہاتھوں درج جس نے خرچ کیا۔',
    point1Title: 'رسید نہیں تو اندراج نہیں۔',
    point1Body: 'تصویر رقم کے ساتھ ہی محفوظ ہوتی ہے، اس لیے ”بعد میں دکھا دوں گا“ کی گنجائش نہیں رہتی۔',
    point2Title: 'جو خرچ کرے، وہی درج کرے۔',
    point2Body: 'آپ کا آفس بوائے، دکان کا ملازم یا گھر کا کوئی بھی فرد، اپنے فون سے، عین ادائیگی کے وقت۔',
    point3Title: 'ہر جگہ ایک پورٹ فولیو ہے۔',
    point3Body: 'گھر، ولا، دکان، دفتر یا کلینک۔ ہر ایک کا ہاتھ میں نقد اور آج کا خرچ ایک ہی اسکرین پر، اور منظوری کہیں سے بھی۔',
    point4Title: 'ہر تبدیلی ریکارڈ میں۔',
    point4Body: 'ترمیم ہو، منظوری ہو یا حذف، کس نے کیا، کب اور کیوں، سب محفوظ رہتا ہے، اس لیے حساب ہمیشہ پورا رہتا ہے۔',
    productOf: 'تیار کردہ:',
    sampleLabel: 'Kharcha میں ایک اندراج ایسا دکھتا ہے',
    sampleSpentBy: 'خرچ کرنے والا',
    sampleWho: 'علی، آفس ہیلپر',
    sampleWhen: 'آج، صبح 11:42',
    samplePortfolio: 'پورٹ فولیو: مین آفس',
    sampleItem1: 'پرنٹر پیپر، 2 رِیم',
    sampleItem2: 'چائے اور چینی',
    sampleItem3: 'اسٹیپلر پن، 1 ڈبہ',
    sampleItem4: 'پینے کا پانی، 20 لیٹر',
    sampleTotal: 'کل',
    sampleReceipt: 'رسید کی تصویر ساتھ ہے',
    sampleReceiptBy: 'کاؤنٹر پر علی نے لی',
    sampleWaiting: 'آپ کی منظوری کا انتظار',
    sampleFix: 'درستی',
    sampleReject: 'مسترد',
    sampleApprove: 'منظور',
    morningLabel: 'مالک کی صبح',
    morningPortfolio: 'پورٹ فولیو: دفتر',
    morningDate: 'جمعہ 9 اکتوبر',
    morningSpent: 'آج کا خرچ',
    morningCash: 'عملے کے پاس نقد',
    morningReview: 'منظوری باقی',
    morningReviewCount: '10 پرچیاں',
    morningNoReceipt: 'بغیر رسید',
    morningNoReceiptCount: 'اس مہینے 1',
    morningBilal: 'بلال',
    morningRecharged: 'کو کل رقم دی گئی',
    morningHamza: 'حمزہ',
    morningNoCash: 'کو ابھی تک نقد نہیں دیا گیا',
    morningApproveAll: 'رسید والی Rs 1,000 تک کی سب منظور کریں (9)',
    morningGiveCash: 'نقد دیں',
    noPassword: 'نہ کوئی پاس ورڈ یاد رکھنا، نہ ری سیٹ کرنا۔',
    firstTime: 'پہلی بار؟ یہی طریقہ۔ اس کے فوراً بعد آپ اپنا پہلا پورٹ فولیو بنائیں گے۔',
    workEmail: 'ای میل',
    change: 'بدلیں',
    digitCode: '6 ہندسوں کا کوڈ',
    expiresIn: 'ختم ہونے میں',
    expired5: 'کوڈ ختم ہو گیا',
    sentNow: 'ابھی آپ کی ای میل پر بھیجا گیا۔ نہیں ملا؟',
    noCodeHelp: 'کوڈ نہیں ملا؟ Spam فولڈر دیکھیں، یا دوبارہ بھیجیں پر ٹیپ کریں۔',
    notRegistered: 'صارف نہیں ملا۔ رجسٹریشن کے لیے رابطہ کریں:',
    paused: 'آپ کا ورک اسپیس روک دیا گیا ہے۔ دوبارہ کھلوانے کے لیے kharcha@kcloudai.com سے رابطہ کریں۔',
    tooMany: 'اس ای میل کے لیے بہت زیادہ کوڈ مانگے گئے۔ چند منٹ انتظار کر کے دوبارہ کوشش کریں۔',
    sendAgain: 'دوبارہ بھیجیں',
    sendAgainIn: '{{time}} میں دوبارہ بھیجیں',
    staysPhone: 'اس فون پر 30 دن تک لاگ اِن رہیں گے۔',
    staysBrowser: 'اس براؤزر پر 30 دن تک لاگ اِن رہیں گے۔',
    locationShort: 'ہر خرچہ محفوظ کرنے پر وقت اور آپ کی جگہ محفوظ ہوتی ہے۔ اسے صرف مالکان دیکھ سکتے ہیں۔',
    email: 'ای میل',
    emailPh: 'you@example.com',
    sendCode: 'مجھے کوڈ ای میل کریں',
    codeTitle: '6 ہندسوں کا کوڈ لکھیں',
    codeSent: 'اگر یہ ای میل رجسٹرڈ ہے تو {{email}} پر کوڈ بھیج دیا گیا ہے',
    code: 'کوڈ',
    signIn: 'لاگ اِن کریں',
    resendIn: '{{time}} میں نیا کوڈ',
    resend: 'نیا کوڈ بھیجیں',
    differentEmail: 'دوسری ای میل',
    wrongCode: 'کوڈ غلط ہے۔ دوبارہ کوشش کریں۔',
    expired: 'یہ کوڈ ختم ہو گیا یا بہت بار غلط لکھا گیا۔ نیا کوڈ منگوائیں۔',
    autofill: 'کوڈ پیسٹ کرنے پر خود بھر جائے گا۔ یہ 5 منٹ کے لیے ہے۔',
    locationTitle: 'ہر اندراج کے ساتھ جگہ محفوظ ہوتی ہے',
    locationBody: 'خرچہ محفوظ کرنے پر فون کی جگہ ساتھ محفوظ ہوتی ہے۔ اسے صرف مالکان دیکھ سکتے ہیں۔',
    ok: 'ٹھیک ہے',
  },
  home: {
    hello: 'السلام علیکم',
    cashWithYou: 'آپ کے پاس نقد · کارڈ ٹیپ کریں',
    low: 'کم ہے — پیسے مانگیں',
    recharge: '{{name}} نے {{entity}} کے لیے <b>{{amount}}</b> دیے',
    received: 'مل گئے',
    receivedDone: 'شکریہ — وصولی ہو گئی',
    waiting_one: '{{count}} اندراج بھیجنا باقی',
    waiting_other: '{{count}} اندراجات بھیجنا باقی',
    spentToday: 'آج کا خرچ',
    entries_one: '{{count}} اندراج',
    entries_other: '{{count}} اندراجات',
    history: 'ہسٹری',
    add: 'خرچہ شامل کریں',
    addFor: '{{entity}}: خرچہ شامل کریں یا نقد دیں',
    arrangeReset: 'پہلی ترتیب',
    holdToMove: 'دبا کر کھینچیں اور جگہ بدلیں۔ Alt اور تیر والی کلیدوں سے بھی بدل سکتے ہیں۔',
    dropHint: 'نئی جگہ پر لے جا کر چھوڑ دیں',
    logout: 'لاگ آؤٹ',
    logoutTitle: 'لاگ آؤٹ کریں؟',
    ownerApp: 'مالک کی ایپ',
    logoutBody: 'دوبارہ لاگ اِن کے لیے ای میل سے نیا کوڈ چاہیے ہوگا۔',
  },
  give: {
    chooseTitle: 'آپ کیا کرنا چاہتے ہیں؟',
    inHandOf: '{{entity}} · ہاتھ میں {{amount}}',
    chooseAdd: 'خرچہ شامل کریں',
    chooseAddSub: 'جو چیز آپ نے خریدی',
    chooseGive: 'نقد دیں',
    chooseGiveSub: 'اس نقد میں سے کسی دوسرے خرچ کرنے والے کو دیں',
    title: 'نقد دیں',
    intro: 'اپنے نقد میں سے کچھ کسی دوسرے خرچ کرنے والے کو دیں۔ یہ ابھی آپ کے بٹوے سے کم ہو جائے گا؛ وہ اپنے فون پر «مل گئے» دبائیں گے۔',
    from: 'کس کا پیسہ',
    inHand: 'ہاتھ میں: {{amount}}',
    to: 'کسے دیں',
    nobody: '{{entity}} کے لیے کوئی اور خرچ نہیں کرتا۔',
    choose: 'کسی کو چنیں…',
    amount: 'رقم',
    note: 'نوٹ (اختیاری)',
    notePlaceholder: 'مثلاً دفتر کے سودے کے لیے',
    submit: '{{name}} کو {{amount}} دیں',
    submitEmpty: 'نقد دیں',
    tooMuch: 'آپ کے ہاتھ میں {{amount}} ہیں',
    done: '{{name}} کو {{amount}} دے دیے',
    undo: 'واپس لیں',
    undone: 'واپس ہو گیا: نقد آپ کے بٹوے میں واپس',
    recent: 'آپ نے جو نقد دیا',
    waiting: 'ان کے قبول کرنے کا انتظار',
    accepted: 'قبول ہو گیا',
    none: 'ابھی کچھ نہیں دیا۔',
    back: 'واپس',
  },
  add: {
    close: 'بند کریں',
    backHome: 'واپس ہوم پر',
    back: 'واپس',
    whoseMoney: 'کس کے پیسے؟',
    ownerSays: 'مالک کا پیغام',
    whatTitle: 'کیا خریدا؟',
    usual: 'روز کی چیزیں — ایک ٹیپ میں سب بھر جائے گا',
    orType: 'یا قسم چنیں',
    usualShort: 'روز کی چیزیں',
    moreTypes: 'مزید {{count}} دکھائیں',
    holdToMoveType: 'دبا کر کھینچیں اور ترتیب بدلیں',
    more: 'مزید',
    less: 'کم',
    itemTitle: 'کون سی چیز؟',
    newName: 'نئی چیز کا نام',
    newPh: 'نام لکھیں',
    use: 'ٹھیک',
    noHistory: 'اس قسم میں ابھی کچھ نہیں خریدا۔ نیچے نام لکھیں۔',
    amountTitle: 'کتنے پیسے دیے؟',
    quantity: 'مقدار',
    qtyTitle: 'کتنا خریدا؟',
    qtyPh: 'مقدار',
    unit: 'اکائی',
    amountPaid: 'کتنے پیسے دیے',
    amountPh: 'رقم لکھیں',
    needQty: 'مقدار لکھیں',
    needUnit: 'اکائی چنیں (عدد، کلو، لیٹر…)',
    needAmount: 'جتنے پیسے دیے وہ لکھیں',
    sameAsLast: 'پچھلی بار جتنے',
    next: 'آگے',
    leftAfter: 'بعد میں بچیں گے',
    notEnough: 'اتنے پیسے نہیں',
    proofTitle: 'رسید کی تصویر',
    takePhoto: 'تصویر لیں',
    fromGallery: 'گیلری سے',
    addFromGallery: 'گیلری سے ایک اور تصویر',
    addAnother: 'ایک اور لگائیں',
    addPhoto: 'ایک اور تصویر',
    removePhoto: 'تصویر ہٹائیں',
    photoAdded: 'تصویر لگ گئی',
    preparing: 'تصویر تیار ہو رہی ہے…',
    noReceipt: 'رسید نہیں ہے؟',
    receiptTitle: 'رسید لگائیں',
    receiptHint: 'دکان کا نام، چیزیں اور کل رقم صاف نظر آئیں۔',
    whyNoReceipt: 'رسید کیوں نہیں؟',
    backToPhoto: 'تصویر',
    reasonShop: 'دکان پرچی نہیں دیتی',
    reasonStreet: 'ریڑھی والا',
    reasonLost: 'پرچی گم ہو گئی',
    reasonOther: 'کچھ اور',
    otherPh: 'وجہ لکھیں (کم از کم 5 حروف)',
    ownerWillCheck: 'مالک یہ اندراج چیک کریں گے',
    when: 'کب؟',
    otherDate: 'دوسری تاریخ',
    pickDate: 'تاریخ چنیں',
    prevMonth: 'پچھلا مہینہ',
    nextMonth: 'اگلا مہینہ',
    sameDay_one: '{{date}} کے لیے پہلے سے محفوظ: {{count}} اندراج · {{amount}}',
    sameDay_other: '{{date}} کے لیے پہلے سے محفوظ: {{count}} اندراج · {{amount}}',
    save: 'محفوظ کریں',
    saving: 'محفوظ ہو رہا ہے…',
    hintPhoto: 'محفوظ کرنے کے لیے رسید کی تصویر لیں',
    hintReason: 'محفوظ کرنے کے لیے وجہ چنیں',
    hintOther: 'کم از کم 5 حروف لکھیں',
    dupTitle: 'یہ دوبارہ لگتا ہے',
    dupBody: 'چند منٹ پہلے یہی رقم اسی قسم میں محفوظ کی تھی۔ پھر سے محفوظ کریں؟',
    dupBack: 'واپس جا کر دیکھیں',
    dupSave: 'پھر بھی محفوظ کریں',
    discardTitle: 'محفوظ کیے بغیر جائیں؟',
    discardBody: 'جو بھرا ہے وہ مٹ جائے گا۔',
    keepFilling: 'بھرنا جاری رکھیں',
    leave: 'چھوڑ دیں',
    itemPlaceholder: 'کیا خریدا؟',
    noPhotoYet: 'ابھی تصویر نہیں',
    photos_one: '{{count}} تصویر',
    photos_other: '{{count}} تصاویر',
    noReceiptShort: 'رسید نہیں',
    lastBought: 'پچھلی بار {{ago}} — {{what}}، {{amount}} — {{who}}',
    step: '{{n}} / 3',
    whoPaid: 'پیسے کس نے دیے؟',
  },
  gps: {
    checking: 'آپ کی جگہ معلوم کی جا رہی ہے…',
    why: 'لوکیشن آن ہو تو ہر خریداری کے ساتھ اس کی جگہ بھی محفوظ ہوتی ہے۔',
    retry: 'دوبارہ کوشش کریں',
    turnOn: 'لوکیشن آن کریں',
    skip: 'لوکیشن کے بغیر جاری رکھیں',
    skipNote: 'آپ پھر بھی اپنا والٹ استعمال کر سکتے ہیں۔ خریداری جگہ کے بغیر محفوظ ہوگی۔',
    insecureTitle: 'اس لنک پر لوکیشن کام نہیں کرتی',
    insecureBody: 'خرچہ کو اس کے https:// والے لنک سے کھولیں (جو مالک نے بھیجا)۔ فون صرف محفوظ صفحات کو لوکیشن دیتا ہے۔',
    unsupportedTitle: 'یہ فون لوکیشن نہیں دے سکتا',
    unsupportedBody: 'براؤزر (کروم) اپ ڈیٹ کریں، یا ایسا فون استعمال کریں جس میں لوکیشن (GPS) ہو۔',
    deniedTitle: 'خرچہ کو لوکیشن کی اجازت دیں',
    deniedBody: 'ویب ایڈریس کے ساتھ تالے یا ⓘ پر ٹیپ کریں، پھر Permissions ← Location ← Allow۔ پھر دوبارہ کوشش کریں۔',
    offTitle: 'لوکیشن (GPS) آن کریں',
    offBody: 'لوکیشن آن کریں پر ٹیپ کریں (یا اسکرین کے اوپر سے نیچے سوائپ کر کے Location آن کریں)، پھر واپس آئیں۔',
    timeoutTitle: 'آپ کی جگہ معلوم نہیں ہو سکی',
    timeoutBody: 'دیکھیں کہ لوکیشن آن ہے، کھڑکی کے پاس یا باہر جائیں، پھر دوبارہ کوشش کریں۔',
    weakTitle: 'لوکیشن کا سگنل بہت کمزور ہے',
    weakBody: 'لوکیشن کو High accuracy پر آن کریں، کھڑکی کے پاس یا باہر جائیں، پھر دوبارہ کوشش کریں۔',
  },
  saved: {
    title: 'محفوظ ہو گیا',
    spent: 'خرچ کیے',
    receiptLabel: 'رسید',
    statusLabel: 'حالت',
    balanceNow: '{{entity}} · اب بیلنس',
    queued: 'فون پر محفوظ — انٹرنیٹ آنے پر چلا جائے گا',
    sent: 'مالک کو بھیج دیا',
    another: '{{entity}} کا ایک اور خرچہ',
    undo: 'واپس لیں · {{seconds}}',
    done: 'ٹھیک ہے',
  },
  history: {
    title: 'ہسٹری',
    thisWeek: 'اس ہفتے',
    all: 'سب',
    needsFix: 'درستی چاہیے',
    notSent: 'نہیں گیا',
    photo: 'رسید کی تصویر',
    photoOf: 'تصویر {{n}} از {{count}}',
    photoPrev: 'پچھلی تصویر',
    photoNext: 'اگلی تصویر',
    photoFailed: 'تصویر نہیں کھل سکی۔',
    photoOffline: 'تصویر دیکھنے کے لیے انٹرنیٹ چاہیے۔',
    filterStatus: 'حالت',
    filterPlace: '{{Place}}',
    allPlaces: 'سب جگہیں',
    clearFilters: 'سب دکھائیں',
    noMatch: 'ان فلٹرز کے مطابق کوئی اندراج نہیں۔',
    tapToFix: 'درست کرنے کے لیے ٹیپ کریں',
    tapToReply: 'جواب دینے یا درست کرنے کے لیے ٹیپ کریں',
    messages: 'پیغامات',
    ownerNeedsFix: 'درستی چاہیے',
    ownerRejected: 'مسترد',
    owner: 'مالک',
    you: 'آپ',
    replyLabel: 'مالک کو آپ کا جواب',
    replyHint: 'مثلاً دکان والے نے رسید نہیں دی',
    sendReply: 'جواب بھیجیں',
    sending: 'بھیج رہے ہیں…',
    replyShort: 'کم از کم 2 حروف لکھیں۔',
    replyOffline: 'جواب بھیجنے کے لیے انٹرنیٹ چاہیے۔ آن لائن ہو کر دوبارہ کوشش کریں۔',
    replyFailed: 'جواب نہیں جا سکا۔ دوبارہ کوشش کریں۔',
    replySent: 'جواب بھیج دیا۔ مالک اندراج دوبارہ دیکھیں گے۔',
    orFix: 'یا اندراج خود درست کریں:',
    fixEntry: 'اندراج درست کریں',
    nothing: 'یہاں کچھ نہیں۔',
    earlier: 'پہلے',
    edit: 'بدلیں',
    delete: 'مٹائیں',
    deleteTitle: 'یہ اندراج مٹائیں؟',
    deleteConfirm: '{{amount}} آپ کے {{entity}} بیلنس میں واپس آ جائیں گے۔',
    paidBy: '{{name}} نے دیے',
    paidByOther: 'دوسرے {{place}} نے دیے',
  },
  notes: {
    title: 'اطلاعات',
    bellUnread_one: 'اطلاعات، {{count}} نئی',
    bellUnread_other: 'اطلاعات، {{count}} نئی',
    unread_one: '{{count}} نئی',
    unread_other: '{{count}} نئی',
    new: 'نئی',
    markAll: 'سب پڑھ لیا',
    empty: 'ابھی کوئی اطلاع نہیں',
    emptyHint: 'جب مالک آپ کو پیغام بھیجیں یا پیسے دیں تو یہاں بتایا جائے گا۔',
    failed: 'اطلاعات نہیں کھل سکیں۔',
    from: '{{name}} کی طرف سے',
    kind: {
      needs_fix: 'واپس آیا: درستی چاہیے',
      rejected: 'مالک نے مسترد کیا',
      cash_in: 'آپ کو پیسے دیے گئے',
    },
  },
  status: {
    pending: 'زیر غور',
    approved: 'منظور',
    rejected: 'مسترد',
    needs_correction: 'درستی چاہیے',
    queued: 'نہیں گیا',
    failed: 'نہیں گیا — درست کریں',
  },
  ago: {
    today: 'آج',
    yesterday: 'کل',
    days_one: '{{count}} دن پہلے',
    days_other: '{{count}} دن پہلے',
  },
  day: { today: 'آج', yesterday: 'گزرا کل', tomorrow: 'آنے والا کل' },
  units: { pcs: 'عدد', kg: 'کلو', g: 'گرام', L: 'لیٹر', ml: 'ملی لیٹر', dozen: 'درجن', pack: 'پیکٹ', bunch: 'گٹھی' },
  cat: {
    veg: 'سبزی',
    fruit: 'پھل',
    meat: 'گوشت',
    rice: 'چاول آٹا',
    dairy: 'دودھ انڈے',
    oil: 'تیل مصالحہ',
    water: 'پانی',
    kitchen: 'کچن کا سامان',
    clean: 'صفائی',
    washroom: 'واش روم',
    stationery: 'اسٹیشنری',
    printing: 'پرنٹنگ',
    petrol: 'پیٹرول',
    generator: 'جنریٹر',
    electricity: 'بجلی',
    gas: 'گیس',
    phone: 'فون',
    internet: 'انٹرنیٹ',
    repair: 'مرمت',
    plumbing: 'پلمبنگ',
    furniture: 'فرنیچر',
    misc: 'متفرق',
  },
};
